export const translations = {
  wallet_label: 'Portofel',
  wallet_label_upper: 'PORTOFEL',
  balance_label: 'SOLD:',

  voucher_heading_start: 'Revendică-ți ',
  voucher_heading_emphasis: 'recompensa',
  voucher_subtitle: 'Te rugăm să selectezi cuponul dorit.',
  voucher_remaining: '{0} Rămase',
  voucher_daily_limit: 'Limita zilnică atinsă',
  submit_btn: 'TRIMITE',
  go_to_site: 'Mergi la {0}',

  menu_coupons: 'CUPOANE',
  menu_balance: 'Sold',
  menu_validity: 'Valabilitate Cupon',
  menu_terms: 'Termeni și Condiții',

  coupon_status_claimed: 'Revendicat',
  coupon_status_active: 'Activ',
  coupon_expires: 'Expiră {0}',
  view_pin: 'Vezi PIN-ul',
  historic_coupons: 'CUPOANE ISTORICE',
  no_active_coupons: 'Nu există cupoane active încă.',
  no_historic_coupons: 'Nu există cupoane istorice.',

  pin_label: 'PIN:',
  pin_copy: 'Copiază',

  validity_heading: 'VALABILITATEA CUPONULUI',
  validity_body_1: 'Transformă acele monede câștigate cu greu în recompense reale! Acum poți cumpăra cupoane direct din magazin folosind soldul tău din joc.',
  validity_body_2: 'Reține: odată ce achiziționezi un PIN, ai 7 zile pentru a-l revendica și încă 30 de zile pentru a-ți reclama premiul. Stocul zilnic este limitat, așa că dacă cuponul tău preferat dispare, încearcă din nou mâine dis-de-dimineață — sau strânge monedele pentru o recompensă și mai valoroasă!',

  terms_heading: 'TERMENI ȘI CONDIȚII RECOMPENSE',

  back_to_store: 'Înapoi la Magazin',
  try_again: 'Încearcă din nou',
}
